export var OrganizationAccessStatus;
(function (OrganizationAccessStatus) {
    OrganizationAccessStatus["ACTIVE"] = "active";
    OrganizationAccessStatus["TRIAL_WARNING"] = "trial_warning";
    OrganizationAccessStatus["TRIAL_EXPIRED"] = "trial_expired";
})(OrganizationAccessStatus || (OrganizationAccessStatus = {}));
//# sourceMappingURL=organizationAccess.js.map